const askquestion = {
    // Header Section
    "discover_your": "మీ",
    "ask_question": "మీ వ్యక్తిగత జ్యోతిష్య",
    "personalized_answers": "ప్రశ్నలకు సమాధానాలు పొందండి",
    "ask_question_description": "మీ జీవితం గురించి ఏదైనా నిర్దిష్ట ప్రశ్న అడిగి వివరమైన జ్యోతిష్య సమాధానాలను పొందండి. మా నిపుణులు, జ్యోతిష్కులు మీ జన్మ కుండలి ఆధారంగా ఆచరణాత్మక మార్గదర్శకత్వం మరియు పరిహార పరిష్కారాలతో వ్యక్తిగత అంతర్దృష్టిని అందిస్తారు.",

    // Service Information
    "enter_details_for_question": "మీ వివరాలు & ప్రశ్న నమోదు చేయండి",
    "personalized_question_answer": "వ్యక్తిగత ప్రశ్న సమాధానం",
    "service_price": "సేవా మూల్యం",
    "personalized_question_answer_note": "మీ నిర్దిష్ట ప్రశ్నకు మార్గదర్శకత్వంతో కూడిన నిపుణులు, జ్యోతిష్య సమాధానం",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరు నమోదు చేయండి",
    "name_question_context": "మీ పేరు మీ ప్రశ్నకు వ్యక్తిగత సందర్భం అందించడంలో సహాయపడుతుంది",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామా నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబర్ నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_question_context": "జ్యోతిష్య సందర్భం మరియు ఖచ్చితమైన సమాధానం కోసం అవసరం",
    "your_question": "మీ ప్రశ్న",
    "enter_your_question": "మీ నిర్దిష్ట ప్రశ్నను ఇక్కడ నమోదు చేయండి...",
    "question_guidance": "స్పష్టంగా మరియు నిర్దిష్టంగా ఉండండి. కెరీర్, ప్రేమ, ఆర్థికాలు, ఆరోగ్యం, కుటుంబం లేదా ఏదైనా జీవిత విషయం గురించి అడుగండి",
    "question_category": "ప్రశ్న వర్గం",
    "select_category": "ప్రశ్న వర్గం ఎంచుకోండి",
    "career_question": "కెరీర్ & వ్యాపారం",
    "love_relationship_question": "ప్రేమ & సంబంధాలు",
    "finance_question": "ఆర్థికాలు & డబ్బు",
    "health_question": "ఆరోగ్యం & క్షేమం",
    "family_question": "కుటుంబం & వ్యక్తిగతం",
    "spiritual_question": "ఆధ్యాత్మిక & అభివృద్ధి",
    "general_question": "సాధారణ జీవితం",
    "category_helps_accuracy": "వర్గం ఎంపిక మరింత ఖచ్చితమైన మరియు సంబంధిత సమాధానాలు అందించడంలో సహాయపడుతుంది",
    "preferred_language": "ఇష్టపడే భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ సమాధానం ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Question Features
    "detailed_answer_explanation": "వివరమైన సమాధానం & వివరణ",
    "astrological_context": "జ్యోతిష్య సందర్భం",
    "timing_guidance": "సమయ మార్గదర్శకత్వం",
    "remedial_suggestions": "పరిహార సూచనలు",
    "follow_up_guidance": "అనుసరణ మార్గదర్శకత్వం",
    "pdf_answer_report": "PDF సమాధాన నివేదిక",

    "what_you_get": "మీ సమాధానంలో ఉన్నవి",
    "comprehensive_answer": "సమగ్ర సమాధానం",
    "astrological_insights": "జ్యోతిష్య అంతర్దృష్టులు",
    "practical_guidance": "ఆచరణాత్మక మార్గదర్శకత్వం",
    "remedial_solutions": "పరిహార పరిష్కారాలు",

    // Actions & Buttons
    "pay_and_get_answer": "నా సమాధానం పొందండి",
    "processing_payment": "చెల్లింపు ప్రాసెస్ చేస్తున్నాము",
    "processing_request": "ప్రశ్న ప్రాసెస్ చేస్తున్నాము",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "question_answer_processing": "మీ ప్రశ్న మా నిపుణ జ్యోతిష్కులచే విశ్లేషించబడుతోంది. మీరు జ్యోతిష్య అంతర్దృష్టులు మరియు ఆచరణాత్మక మార్గదర్శకత్వంతో కూడిన వివరమైన వ్యక్తిగత సమాధానం పొందుతారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "పేమెంట్ ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "సమాధాన డెలివరీ",
    "within_6_hours_delivery_note": "మీ వివరమైన సమాధానం 6 గంటలలోపు సిద్ధంగా ఉంటుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్లు పొందండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి సమాధానం డెలివర్ చేయబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ సమాధాన ప్యాకేజీ",
    "detailed_answer_report_pdf": "వివరమైన సమాధాన నివేదిక (PDF)",
    "astrological_explanation": "జ్యోతిష్య వివరణ",
    "timing_recommendations": "సమయ సిఫారసులు",
    "remedial_measures": "పరిహార చర్యలు",
    "action_plan_guidance": "కార్యాచరణ ప్రణాళిక మార్గదర్శకత్వం",

    // Visual Content
    "sample_question_answer": "నమూనా ప్రశ్న సమాధానం",
    "expert_answer": "నిపుణుల సమాధానం",
    "sample_answer_preview": "ఆచరణాత్మక మార్గదర్శకత్వం మరియు సమయంతో కూడిన వివరమైన జ్యోతిష్య అంతర్దృష్టులు",
    "sample_question_preview": "మా నిపుణులు మీ నిర్దిష్ట ప్రశ్నలకు ఎలా సమాధానం ఇస్తారో చూడండి",
    "question_categories": "ప్రశ్న వర్గాలు",

    // Question Category Types
    "career": "కెరీర్",
    "love": "ప్రేమ",
    "finance": "ఆర్థికాలు",
    "health": "ఆరోగ్యం",
    "family": "కుటుంబం",
    "spiritual": "ఆధ్యాత్మిక",

    // Status & Processing
    "your_question_status": "మీ ప్రశ్న స్థితి",
    "processing_your_question": "మీ ప్రశ్న విశ్లేషిస్తున్నాము",
    "question_processing_message": "మా నిపుణ జ్యోతిష్కులు మీ జన్మ కుండలిని అధ్యయనం చేసి మీ ప్రశ్నను విశ్లేషిస్తూ అత్యంత ఖచ్చితమైన మరియు సహాయకరమైన సమాధానం అందించడానికి కృషి చేస్తున్నారు.",
    "request_id": "ప్రశ్న ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో",
    "pending": "వేచి ఉన్న",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్లు ప్రారంభించబడ్డాయి",
    "delivery_within_6_hours": "సమాధానం 6 గంటలలో సిద్ధం",

    // Support & Contact
    "contact_support": "ప్రశ్న మద్దతు సంప్రదించండి",
    "need_help": "మార్గదర్శకత్వం అవసరమా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి మీ ప్రశ్నతో సహా అన్ని అవసరమైన ఫీల్డ్‌లను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "ప్రశ్న ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Question Types & Examples
    "career_questions_examples": "కెరీర్ ప్రశ్నల ఉదాహరణలు",
    "when_promotion": "నాకు ఎప్పుడు పదోన్నతి వస్తుంది?",
    "job_change_timing": "నేను ఇప్పుడు ఉద్యోగం మార్చుకోవాలా?",
    "business_success": "నా వ్యాపారం విజయవంతం అవుతుందా?",
    "career_path": "మీ జీవితానికి అనుకూలమైన ఉత్తమ కెరీర్ మార్గం ఏమిటో తెలుసుకోండి",

    "love_questions_examples": "ప్రేమ ప్రశ్నల ఉదాహరణలు",
    "marriage_timing": "నాకు ఎప్పుడు వివాహం అవుతుంది?",
    "relationship_future": "నా సంబంధం యొక్క భవిష్యత్తు ఎలా ఉంటుంది?",
    "soulmate_meeting": "నేను నా జీవిత భాగస్వామిని ఎప్పుడు కలుస్తాను?",
    "love_compatibility_question": "మేము వివాహానికి అనుకూలంగా ఉన్నామా?",

    "finance_questions_examples": "ఆర్థిక ప్రశ్నల ఉదాహరణలు",
    "money_problems": "నా ఆర్థిక సమస్యలు ఎప్పుడు అంతమవుతాయి?",
    "investment_timing": "ఇది పెట్టుబడి పెట్టడానికి మంచి సమయమా?",
    "property_purchase": "నేను ఇప్పుడు ఆస్తి కొనుగోలు చేయాలా?",
    "debt_relief": "నేను ఎప్పుడు అప్పుల నుండి బయటపడతాను?",

    "health_questions_examples": "ఆరోగ్య ప్రశ్నల ఉదాహరణలు",
    "health_recovery": "నా ఆరోగ్యం ఎప్పుడు మెరుగుపడుతుంది?",
    "surgery_timing": "ఇది శస్త్రచికిత్సకు మంచి సమయమా?",
    "chronic_illness": "నా దీర్ఘకాలిక వ్యాధి నయమవుతుందా?",
    "fitness_goals": "నేను నా ఆరోగ్య లక్ష్యాలను ఎలా సాధించగలను?",

    // Answer Components
    "question_analysis": "ప్రశ్న విశ్లేషణ",
    "birth_chart_insights": "జన్మ కుండలి అంతర్దృష్టులు",
    "planetary_influences": "గ్రహ ప్రభావాలు",
    "current_transits": "ప్రస్తుత గ్రహ సంచార ప్రభావాలు",
    "dasha_analysis": "దశా కాలం విశ్లేషణ",
    "yogas_doshas": "సంబంధిత యోగాలు & దోషాలు",

    // Timing Analysis
    "favorable_periods": "అనుకూల కాలాలు",
    "challenging_periods": "సవాలు కాలాలు",
    "optimal_timing": "అత్యుత్తమ సమయం",
    "avoid_periods": "తప్పించవలసిన కాలాలు",
    "gradual_improvement": "క్రమంగా మెరుగుదల కాలక్రమం",
    "sudden_changes": "అకస్మాత్ మార్పుల అవకాశాలు",

    // Remedial Solutions
    "gemstone_remedies": "రత్న పరిహారాలు",
    "mantra_recommendations": "మంత్ర సిఫారసులు",
    "charity_suggestions": "దాన కార్యక్రమాలు",
    "ritual_guidance": "కర్మ & పూజా మార్గదర్శకత్వం",
    "lifestyle_changes": "జీవనశైలి మార్పులు",
    "behavioral_adjustments": "ప్రవర్తనా సవరణలు",

    // Practical Guidance
    "action_steps": "సిఫార్సు చేసిన చర్య దశలు",
    "do_and_dont": "చేయవలసినవి & చేయకూడనివి",
    "precautions": "తీసుకోవలసిన జాగ్రత్తలు",
    "opportunities": "గమనించవలసిన అవకాశాలు",
    "preparation_tips": "తయారీ చిట్కాలు",
    "patience_guidance": "ఎప్పుడు ఓపికగా ఉండాలి",

    // Follow-up Information
    "progress_tracking": "పురోగతి ట్రాకింగ్",
    "reassessment_timing": "ఎప్పుడు మళ్లీ అంచనా వేయాలి",
    "additional_questions": "పరిగణించవలసిన సంబంధిత ప్రశ్నలు",
    "ongoing_guidance": "కొనసాగుతున్న మార్గదర్శకత్వం",
    "support_resources": "మద్దతు వనరులు",
    "expert_consultation": "నిపుణ సంప్రదింపులు అందుబాటులో",

    // Question Quality Guidelines
    "specific_questions": "నిర్దిష్ట ప్రశ్నలు అడుగండి",
    "avoid_yes_no": "సాధారణ అవును/కాదు ప్రశ్నలను తప్పించండి",
    "include_context": "సంబంధిత సందర్భాన్ని చేర్చండి",
    "one_main_question": "ఒక ప్రధాన ప్రశ్నపై దృష్టి పెట్టండి",
    "clear_timeline": "కావలసిన కాలవ్యవధిని పేర్కొనండి",
    "personal_concerns": "వ్యక్తిగత ఆందోళనలను వ్యక్తపరచండి",

    // Answer Accuracy Factors
    "birth_time_accuracy": "జన్మ సమయ ఖచ్చితత్వం ముఖ్యం",
    "current_circumstances": "ప్రస్తుత జీవిత పరిస్థితులు",
    "personal_efforts": "వ్యక్తిగత ప్రయత్నాలు ముఖ్యం",
    "free_will_factor": "స్వేచ్ఛా సంకల్ప పరిగణనలు",
    "karmic_influences": "కర్మ ప్రభావాలు",
    "divine_grace": "దైవిక అనుగ్రహ అంశం",

    // Special Question Categories
    "urgent_questions": "అత్యవసర జీవిత ప్రశ్నలు",
    "long_term_planning": "దీర్ఘకాలిక జీవిత ప్రణాళిక",
    "decision_making": "ముఖ్యమైన నిర్ణయ తీసుకోవడం",
    "crisis_management": "సంక్షోభం & సవాలు నిర్వహణ",
    "opportunity_evaluation": "అవకాశ మూల్యాంకనం",
    "relationship_counseling": "సంబంధ మార్గదర్శకత్వం",

    // Confidentiality
    "privacy_assurance": "పూర్తి గోప్యత హామీ",
    "confidential_handling": "గోప్యమైన ప్రశ్న నిర్వహణ",
    "secure_communication": "సురక్షిత కమ్యూనికేషన్",
    "expert_discretion": "నిపుణ విచక్షణ నిర్వహించబడుతుంది",
    "no_judgment": "తీర్పు రహిత విధానం",
    "supportive_guidance": "మద్దతు & దయతో కూడిన మార్গదర్శకత్వం"
};

export default askquestion;
